// Fades in content as it scrolls into view. Skips entirely when the visitor
// prefers reduced motion, and never touches .hero__media so the LCP image
// always paints immediately instead of waiting on JS + a scroll trigger.
const revealElements = document.querySelectorAll(
  '.card-wrapper, .gallery-slide, .collection-card, [data-reveal]'
);

if (revealElements.length === 0) {
  // nothing to do
} else if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) {
  revealElements.forEach((el) => el.classList.add('reveal-on-scroll', 'is-visible'));
} else {
  revealElements.forEach((el) => el.classList.add('reveal-on-scroll'));

  const observer = new IntersectionObserver(
    (entries) => {
      for (const entry of entries) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          // Release the compositing layer once the animation has settled.
          entry.target.addEventListener('transitionend', () => (entry.target.style.willChange = 'auto'), {
            once: true,
          });
          observer.unobserve(entry.target);
        }
      }
    },
    { rootMargin: '0px 0px -50px 0px', threshold: 0.1 }
  );

  revealElements.forEach((el) => observer.observe(el));
}
